import React, { useEffect, useRef, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import AddTaskPopup from './Calander/AddTaskPopup';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import RecurranceUpdateInstancePopup from './Appointment/RecurranceUpdateInstancePopup';
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchParams } from '../../redux/slices/scheduler/appointmentSlice';
import { getMaskDate } from '../../Utilities/Utilities';
import { debounce } from 'lodash';

function AppTask() {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { appSearchPrams } = useSelector((store) => store.appointment);

  const [addTask, setAddTask] = useState(false);
  const [resName, setResName] = useState('');
  const [taskDescription, setTaskDescription] = useState('');
  const [recurrance, setRecurrance] = useState('');
  const [isblocked, setIsBlocked] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [addedDate, setAddedDate] = useState('');
  const selectRef = useRef();
  const [taskList, setTaskList] = useState([]);
  const [resourceList, setResourceList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [resId, setResId] = useState(appSearchPrams?.allProviders);
  const [location, setLocation] = useState(appSearchPrams.clinicLocation);
  const [weeklyfilter, setWeeklyfilter] = useState('ALL');
  const [conFirmDelete, setConFirmDelete] = useState({
    status: false,
    deltaskData: '',
    delType: '0',
  });
  const [reload, setReload] = useState(false);
  const [recurranceInstancePopup, setRecurranceInstancePopup] = useState(false);
  const [updateInstanceFlag, setUpdateInstanceFlag] = useState(false);
  const [askRecurrData, setAskRecurrData] = useState('');
  const [taskData, setTaskData] = useState('');
  const [editTaskData, setEditTaskData] = useState('');
  const [debouncedFilters, setDebouncedFilters] = useState({
    resName: '',
    taskDescription: '',
    startDate: '',
    endDate: '',
    addedDate: '',
  });

  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedFilters({
        resName,
        taskDescription,
        startDate,
        endDate,
        addedDate,
      });
    }, 500);

    handler();
    return () => handler.cancel();
  }, [resName, taskDescription, startDate, endDate, addedDate]);

  const handleReload = () => {
    setReload(!reload);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/manageTaskList',
          {
            resourceId: resId,
            resourceName: debouncedFilters.resName,
            desc: debouncedFilters.taskDescription,
            recurring_status: recurrance,
            block_status: isblocked,
            startDate: debouncedFilters.startDate,
            endDate: debouncedFilters.endDate,
            addedDate: debouncedFilters.addedDate,
            weeklyFilter: weeklyfilter,
            taskLocation: location,
          },
        );
        if (response.status === 200) {
          setTaskList(response?.data?.taskListArr);
          setResourceList(response?.data?.resourceList);
          setLocationList(response?.data?.allLocation);
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [
    resId,
    weeklyfilter,
    debouncedFilters,
    recurrance,
    isblocked,
    reload,
    location,
  ]);

  const manageRecurrBlockData = async (task, actionType) => {
    if (task?.recurring_id !== '0') {
      try {
        const response = await post(
          'api/appointment/Appointment/showAskPopupForRecurringBlock',
          {
            taskId: task?.taskId,
            recurringId: task?.recurring_id,
            placeOfDel: '0',
            actionType: actionType, //0->change, 1->delete
          },
        );
        if (response.status === 200) {
          setAskRecurrData(response?.data);
          setRecurranceInstancePopup(true);
          setTaskData(task);
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    } else {
      if (actionType === '0') changeTask(task?.taskId, '0', '0');
      if (actionType === '1') handleDeleteTask(task, '0');
    }
  };

  const changeTask = async (taskId, recurrId, delType) => {
    try {
      const response = await post(
        'api/appointment/Appointment/changeThisTaskPop',
        {
          id: taskId, //taskId
          recurringId: recurrId,
          placeOfDel: '0',
          delType: delType, //'0' -> for one, '1' -> for all
        },
      );
      if (response?.status === 200) {
        setEditTaskData(response?.data);
        setUpdateInstanceFlag(delType);
        setAddTask(true);
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  const handleMainDateChange = (date) => {
    const formattedDate = format(date, DEFAULT_DATE_FORMATE);
    selectRef.current.value = formattedDate;
    selectRef.current.text = formattedDate;
    selectRef.current.classList.remove('hide');
    setWeeklyfilter(formattedDate);
  };

  const handleDeleteTask = (task, val) => {
    setConFirmDelete((prev) => ({
      ...prev,
      status: true,
      deltaskData: task,
      delType: val,
    }));
  };

  const handleDeleteTempletConfirm = async (parms) => {
    const response = await post('api/appointment/appointment/deleteThisTask', {
      taskId: parms?.deltaskData?.taskId,
      recurringId: parms?.deltaskData?.recurring_id,
      placeOfDel: '0',
      delType: parms?.delType, //'0' -> for one, '1' -> for all
      loginUserId: user?.id,
    });
    if (response.status === 200) {
      if (response.data?.status === '1') {
        setUiMessage('suc', 'Task delete successfully');
        handleReload();
      } else {
        setUiMessage('err', 'Something went wrong. Unable to delete task.');
      }
    }
  };

  return (
    <div>
      <div className="qc-mid-bdy-hdr clear-top10 flex-sec">
        <span className="widget-hdr-title bold clear-top hide">Task:</span>
        <div className="flex-sec" style={{ width: '86%', marginLeft: '0' }}>
          <div className="flex-sec" style={{ width: '25%' }}>
            <span className="doc-hdr-lbl black-txt">Display:</span>
            <span className="doc-hdr-val" style={{ width: '72%' }}>
              <select
                className="inpt-width-nw"
                onChange={(e) => {
                  setWeeklyfilter(e.target.value);
                  selectRef.current.value = '';
                  selectRef.current.text = '';
                  selectRef.current.classList.add('hide');
                }}
                value={weeklyfilter || ''}
                style={{ marginRight: '0', width: '100%' }}
              >
                <option value="TD">Today</option>
                <option value="YD">Yesterday</option>
                <option value="TW">This Week</option>
                <option value="LW">Last Week</option>
                <option value="TM">This Month</option>
                <option value="LM">Last Month</option>
                <option value="ALL">All</option>
                <option ref={selectRef} className="hide" value=""></option>
              </select>
            </span>
          </div>
          <div className="flex-sec" style={{ margin: '4px 0px 0px 5px' }}>
            <ReactDatePicker
              selected={new Date()}
              onChange={(date) => handleMainDateChange(date)}
              customInput={
                <img
                  src={'./images/calendar-icon.png'}
                  alt="Calendar"
                  width={'30px'}
                />
              } // Use the image as the custom input
              dateFormat={DEFAULT_DATE_FORMATE}
            />
          </div>

          <div className="flex-sec clear-left">
            <span className="doc-hdr-lbl black-txt">Resource:</span>
            <span className="doc-hdr-val">
              <select
                className="inpt-width-nw"
                value={resId || ''}
                onChange={(e) => {
                  setResId(e.target.value);
                  dispatch(
                    updateSearchParams({
                      key: 'allProviders',
                      value: e.target.value,
                    }),
                  );
                }}
              >
                <option value="ALL">ALL</option>
                {resourceList &&
                  resourceList.length > 0 &&
                  resourceList.map((item, index) => {
                    return (
                      <option key={item?.id} value={item?.id}>
                        {item?.resName}
                      </option>
                    );
                  })}
              </select>
            </span>
          </div>
          <div className="flex-sec clear-left">
            <span className="doc-hdr-lbl black-txt">Location:</span>
            <span className="doc-hdr-val">
              <select
                className="inpt-width-nw"
                value={location || ''}
                onChange={(e) => {
                  setLocation(e.target.value);
                  dispatch(
                    updateSearchParams({
                      key: 'clinicLocation',
                      value: e.target.value,
                    }),
                  );
                }}
              >
                <option value="">ALL</option>
                {locationList &&
                  locationList.length > 0 &&
                  locationList.map((item, index) => {
                    return (
                      <option key={item?.id} value={item?.id}>
                        {item?.location_code}
                      </option>
                    );
                  })}
              </select>
            </span>
          </div>
        </div>
        <span
          className="actn-yes center"
          style={{
            width: '12%',
            height: '27px',
            paddingTop: '5px',
            marginTop: '4px',
          }}
          onClick={() => {
            setAddTask(true);
            setEditTaskData(null);
            setUpdateInstanceFlag(false);
          }}
        >
          Add Task
        </span>
        {addTask && (
          <AddTaskPopup
            key={Math.random()}
            handleClose={() => {
              setAddTask(false);
            }}
            handleReload={handleReload}
            eventData={editTaskData}
            recurrCheck={updateInstanceFlag} // to activate delete from task list
          />
        )}
      </div>
      <div></div>
      <div className="tgrid-hdr appt-body-hdr-fltr-rw grid-sec clear-top10">
        <div className="tgrid-tphdr flex-sec">
          <span className="left ">Resource Name</span>
          <span className="left ">Task description</span>
          <span className="left ">Recurrence</span>
          <span className="left ">Blocked</span>
          <span className="left ">Start</span>
          <span className="left ">End</span>
          <span className="left ">Added date</span>
          <span className="left ">Location</span>
          <span className="left ">Action</span>
        </div>
        <div className="tgrid-lwhdr flex-sec">
          <span className="left ">
            <input
              type="search"
              className="inpt-width-nw"
              value={resName || ''}
              onChange={(e) => {
                setResName(e.target.value);
              }}
            />
          </span>
          <span className="left ">
            <input
              type="search"
              className="tgrid-srch"
              value={taskDescription || ''}
              onChange={(e) => {
                setTaskDescription(e.target.value);
              }}
            />
          </span>
          <span className="left ">
            <select
              className="tgrid-slctbx width100"
              value={recurrance || ''}
              onChange={(e) => {
                setRecurrance(e.target.value);
              }}
            >
              <option value="">Select</option>
              <option value={'1'}>Yes</option>
              <option value={'0'}>No</option>
            </select>
          </span>
          <span className="left ">
            <select
              className="tgrid-slctbx width100"
              value={isblocked || ''}
              onChange={(e) => {
                setIsBlocked(e.target.value);
              }}
            >
              <option value="">Select</option>
              <option value={'0'}>Yes</option>
              <option value={'1'}>No</option>
            </select>
          </span>
          <span className="left ">
            <input
              type="search"
              className="tgrid-srch"
              value={startDate || ''}
              onChange={(e) => {
                setStartDate(getMaskDate(e.target.value));
              }}
            />
          </span>
          <span className="left ">
            <input
              type="search"
              className="tgrid-srch"
              value={endDate || ''}
              onChange={(e) => {
                setEndDate(getMaskDate(e.target.value));
              }}
            />
          </span>
          <span className="left ">
            <input
              type="search"
              className="tgrid-srch"
              value={addedDate || ''}
              onChange={(e) => {
                setAddedDate(getMaskDate(e.target.value));
              }}
            />
          </span>
          <span className="left ">
            {/* <select
              className="tgrid-slctbx width100"
              value={recurrance || ''}
              onChange={(e) => {
                setRecurrance(e.target.value);
              }}
            >
              <option value="">Select</option>
              <option value={'1'}>Yes</option>
              <option value={'0'}>No</option>
            </select> */}
          </span>
          <span className="left "></span>
        </div>
      </div>
      <div className="tgrid-bdy grid-sec width100">
        {taskList && taskList.length > 0 ? (
          taskList.map((task, index) => {
            return (
              <div
                key={task?.taskId}
                className={`tgrid-rw flex-sec width100 ${
                  index % 2 === 0 ? '' : 'alt-rw'
                }`}
              >
                <span className="left ">{task?.resourceName}</span>
                <span className="left ">{task?.task_description}</span>
                <span className="left ">{task?.recurring}</span>
                <span className="left ">{task?.blocked}</span>
                <span className="left ">{task?.start_date}</span>
                <span className="left ">{task?.end_date}</span>
                <span className="left ">{task?.date_added}</span>
                <span className="left ">
                  {task?.location_code ? task?.location_code : 'ALL'}
                </span>
                <span className="left ">
                  <Link
                    onClick={() => {
                      manageRecurrBlockData(task, '0');
                    }}
                  >
                    Change
                  </Link>
                  <span style={{ margin: 'unset' }}> | </span>
                  <Link
                    // onClick={() => handleDeleteTask(task?.id)}
                    onClick={() => {
                      manageRecurrBlockData(task, '1');
                    }}
                  >
                    Delete
                  </Link>
                </span>
              </div>
            );
          })
        ) : (
          <p className="no-appoinmnts-here">No record found. !!</p>
        )}
      </div>
      {recurranceInstancePopup && (
        <RecurranceUpdateInstancePopup
          handleClose={() => setRecurranceInstancePopup(false)}
          data={askRecurrData}
          callback={(val) => {
            if (askRecurrData?.statusTxt === 'Change')
              changeTask(taskData?.taskId, taskData?.recurring_id, val);
            if (askRecurrData?.statusTxt === 'Delete')
              handleDeleteTask(taskData, val);
          }}
        />
      )}

      {conFirmDelete?.status && (
        <ConfirmDialog
          title="Confirm"
          bodytext="Do you want to delete this task?"
          sucPrams={conFirmDelete}
          closeDialog={() =>
            setConFirmDelete((prev) => ({ ...prev, status: false }))
          }
          successDialog={handleDeleteTempletConfirm}
        />
      )}
    </div>
  );
}

export default AppTask;
